import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export default function TopLabelsBarList({ items = [] }) {
  const top = (items || []).slice(0, 3); // top 3

  if (!top.length) return null;

  return (
    <Grid container spacing={2} sx={{ mt: 0.5 }}>
      {top.map((it, i) => {
        const color = it.icon?.color || "info";

        // 👇 nombre del sello (vemos varias opciones)
        const rawLabel =
          it.label_name ??
          it.labelName ??
          it.record_label_name ??
          it.recordLabelName ??
          it.label ??
          it.name ??
          (typeof it.record_label === "object"
            ? it.record_label.name ?? it.record_label.nombre
            : typeof it.record_label === "string"
            ? it.record_label
            : null);


        // si el "nombre" parece sólo un número cortito, lo consideramos ID
        const looksLikeId =
          rawLabel &&
          /^\d+$/.test(String(rawLabel).trim()) &&
          String(rawLabel).length <= 5;

        const label =
          !rawLabel || looksLikeId
            ? `Sello #${it.id ?? it._id ?? "?"}`
            : rawLabel;

        const match = typeof rawLabel === "string" ? rawLabel.match(/#(\d+)/) : null;
        const inferredId = match ? match[1] : null;
            

        // 👇 cantidad (puede venir en varias claves)
        const value =
          it.progress?.content ??
          it.count ??
          it.total ??
          it.value ??
          0;

        return (
          <Grid key={`${label}-${i}`} item xs={12} sm={4}>
            <SoftBox
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              gap={0.25}
            >
              <SoftBox display="flex" alignItems="center" gap={0.75}>
                <SoftBox
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    width: 22,
                    height: 22,
                    borderRadius: "8px",
                    color: "#fff",
                    background: (t) =>
                      t.palette[color]?.main || t.palette.info.main,
                    flex: "0 0 auto",
                  }}
                >
                  <Icon fontSize="small">
                    {it.icon?.component || "library_music"}
                  </Icon>
                </SoftBox>

                {/* nombre completo, puede ocupar 2 líneas */}
                <SoftTypography
                  variant="button"
                  color="text"
                  sx={{
                    whiteSpace: "normal",
                    overflow: "visible",
                    textOverflow: "unset",
                  }}
                >
                  {label}
                </SoftTypography>
              </SoftBox>

              {/* cantidad */}
              <SoftTypography variant="h6" sx={{ lineHeight: 1.2 }}>
                {value}
              </SoftTypography>
            </SoftBox>
          </Grid>
        );
      })}
    </Grid>
  );
}
